
import { computed, defineComponent, reactive, ref } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { axiosSetting } from '@/utils/axiosSetting'
import axios from 'axios'
import Button from '@/components/elements/Button.vue'
import InputCheckboxSimple from '@/components/elements/InputCheckboxSimple.vue'
import CbtAnswerCommentaryItem from '@/components/block/CbtAnswerCommentaryItem.vue'
import CbtResultChart from '@/components/block/CbtResultChart.vue'
import CbtLatestScore from '@/components/block/CbtLatestScore.vue'

const parsePastPerformance = (
  pastPerformance: { last_test_day: string; score: number }[]
) => {
  const dateLabels: string[] = []
  const scores: number[] = []
  pastPerformance.forEach((performance) => {
    dateLabels.unshift(performance.last_test_day.split(' ')[0])
    scores.unshift(performance.score)
  })
  return {
    dateLabels,
    scores
  }
}
export default defineComponent({
  name: 'CbtResult',
  components: {
    Button,
    InputCheckboxSimple,
    CbtAnswerCommentaryItem,
    CbtResultChart,
    CbtLatestScore
  },

  setup() {
    // lsの値をクリアする処理
    localStorage.setItem('myAnswers', '')

    // 項名をセット
    const route = useRoute()
    const categoryString = route.params.category + ''
    const categoryNumber = Number(
      categoryString.substring(categoryString.length - 1)
    )
    const setTermTitle = () => {
      const titles = [
        '第一項 基本事項 / 医学一般(30問)',
        '第二項 人体各器官の正常構造と機能、病態、診断、治療(30問)',
        '第三項 全身に及ぶ生理的変化、病態、診断、治療(30問)',
        '第四項 診療の基本 / 社会と医学・医療(30問)',
        '第五項 4連問特集(20問)'
      ]
      return titles[categoryNumber - 1]
    }
    // 満点をセット
    const setMaxScore = () => {
      return categoryNumber !== 5 ? 30 : 20
    }

    const graphTitle = () => {
      if (window.matchMedia('(min-width: 768px)').matches) return setTermTitle()
      const spGraphTitles = [
        '第一項 基本事項 / 医学一般(30問)',
        ['第二項 人体各組織の正常構造と', '機能、病態、診断、治療(30問)'],
        ['第三項 全身に及ぶ生理的変化、', '病態、診断、治療(30問)'],
        ['第四項 診療の基本 / 医学、', '医療と社会(30問)'],
        '第五項 4連問特集(20問)'
      ]
      return spGraphTitles[categoryNumber - 1]
    }

    const result = ref({})
    const answer_commentary = ref([])
    const store = useStore()

    // wpとバックエンドのマージ関数
    const mergedResult: any[] = reactive([])
    const mergeData = (backendCommentary: Array<any>, wpData: Array<any>) => {
      backendCommentary.forEach((bItem) => {
        const targetItem = wpData.find((wItem) => wItem.id == bItem.wpqno)
        if (targetItem) {
          mergedResult.push({ ...targetItem, ...bItem })
        }
      })
    }

    // 解答解説の絞り込み処理
    const filtered = ref(false)
    const toggleFilter = () => {
      filtered.value = !filtered.value
    }
    const filteredData = computed(() => {
      if (filtered.value) {
        return mergedResult.filter((item) => {
          const correctAnswer = item.answers.find(
            (key: any) => key.right_flag === true
          )
          return correctAnswer.answer_check !== item.answer
        })
      } else {
        return mergedResult
      }
    })

    // バックエンド,wpまとめてのapi処理関数
    // wpのapi
    const WP_API_BASE_URL = process.env.VUE_APP_WPAPI_URL || ''
    const WP_API_TIMEOUT = 30000
    const WP_API_BASIC_AUTH = {
      username: process.env.VUE_APP_WPAPI_USER || '',
      password: process.env.VUE_APP_WPAPI_PASS || ''
    }
    const wpDistJson = axios.create({
      baseURL: `${WP_API_BASE_URL}/dist/`,
      auth: WP_API_BASIC_AUTH,
      timeout: WP_API_TIMEOUT
    })

    const ajax = axiosSetting('app', 'action')
    const params = {
      users_id: store.state.userInfo.zip,
      year: '2022',
      term: categoryNumber
    }
    const getData = async () => {
      const promise = []
      // バックエンドapi
      promise[0] = ajax.post('/api/v1/cbt_results', params).then((res: any) => {
        const chartData = parsePastPerformance(res.data.past_performance)
        return { ...res.data, ...chartData }
      })
      promise[1] = wpDistJson.get(`cbt_${categoryNumber}.json`)

      await Promise.all(promise).then((data: any) => {
        for (let i = 0; i < data.length; i++) {
          if (i === 0) {
            result.value = data[i]
            answer_commentary.value = data[i].answer_commentary
          } else {
            mergeData(answer_commentary.value, data[i].data)
          }
        }
      })
    }
    getData()

    const activeAllResult = ref(false)
    const getDataAll = () => {
      ajax.post('/api/v1/cbt_previous_results', params).then((res: any) => {
        activeAllResult.value = res.data.every(
          (item: any) => item.last_test_day !== ''
        )
      })
    }
    getDataAll()

    return {
      setTermTitle,
      graphTitle,
      setMaxScore,
      result,
      answer_commentary,
      mergedResult,
      toggleFilter,
      filteredData,
      activeAllResult
    }
  }
})
